import { getUrlPath } from 'lib/core/resources/helpers'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { getPageList } from 'lib/core/data/common/pageList/selectors'

export const useCmsPageByPath = (urlPath?: string) => {
  const location = useLocation()
  const slug = getUrlPath(location)
  const pageList = useSelector(getPageList)
  const data = pageList?.identifier[urlPath ?? slug]

  return data
}
